// get current tab depending on the url
export const getCurrentTab = (router, tabs, main = null) => {

    var result = '';

    if(tabs && tabs.length > 0){

        // the position 0 is the default one unless you indicate it
        const defaultTab = main ? main : tabs[0];

        const join = tabs.filter(tab => tab !== defaultTab).join('|');
        const regExp = new RegExp(`/([a-zA-Z-_]+)/(${join})$`);

        // if the tab is not the default one and it is on the tabs options
        const path = router.pathname;

        if(regExp.test(path)){

            const matches = path.match(regExp);

            // 0 is the entire path, 1 is the first match group, 2 is the tab
            const tab = matches[2];
            result = tab;
        }
        else{
            result = defaultTab;
        }
    }

    return result?.toString();
}

// get url when tab changes
export const getNewUrl = (router,report,tabs,tab) => {

    var result = router.pathname;

    if(tabs && tabs.length > 0){

        const join = tabs.join('|');
        const regExp = new RegExp(`/([a-zA-Z-_]+)/(${join})$`);
        const path = window.location.pathname;

        // get the current tab to be changed to new one
        if(regExp.test(path)){

            //const matches = path.match(regExp);

            // 0 is the entire path, 1 is the first match group, 2 is the tab
            //const currentTab = matches[2];            

            const newRegExp = new RegExp(`/(${join})$`);
            result = path.replace(newRegExp,'/'+tab);            
        }
        else{
            // if no previous tab, it was on default url with default tab
            // add new tab to url

            // 2 options, or no tab, so default
            // or a wrong option, so remove it and add the new tab
            const regExpDefault = new RegExp(`/${report}$`);
            if(regExpDefault.test(path)){
                result = path+'/'+tab;
            }
            else{
                const regExpWrongOption = new RegExp(`/${report}/([a-zA-Z-_]+)$`);
                result = path.replace(regExpWrongOption,'/'+report+'/'+tab);                
            }
        }
    }

    return result;
}

// get the current option from the url
// for example: /resource_rentals/2 => group 2
export const getCurrentOptions = (router, menu) => {

    var result = [];

    const regExp = new RegExp(`/${menu}((/[a-zA-Z0-9_-]+)*)$`);

    const path = router.pathname;

    if(regExp.test(path)){
        const matches = path.match(regExp);
        result = matches[1].split('/').filter(segment => segment.length > 0);
    }

    return result;
}

// to add options to the url
export const setNewOptions = (router, menu, options = []) => {

    const path = router.pathname;
    var result = path;

    const regExp = new RegExp(`/${menu}((/[a-zA-Z0-9_-]+)*)$`);    

    if(regExp.test(path)){
        
        const matches = path.match(regExp);

        result = path?.replace(matches[1],'');

        if(options && options?.length > 0){
            result = result+'/'+options.join('/');
        }
    }

    return result;

}